import { Box, Slider, Typography } from '@mui/material';
import { DEFAULT_NUMBER_OF_ANSWER_CARDS } from '../../../../../../../AppConstants';
import { filterUndefined } from '../../../../../../../utils/FilterUndefinedObject';

const marks = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
];

const defaultProps = {
  value: DEFAULT_NUMBER_OF_ANSWER_CARDS,
  onSliderChange: () => {},
  flexDirection: 'column',
  sliderWidth: '100%',
  label: 'Choose Number of Cards',
};

const ChooseNumberOfCards = (p) => {
  const {
    onSliderChange,
    flexDirection,
    sliderWidth,
    label,
    ...props
  } = { ...defaultProps, ...filterUndefined(p) };

  return (
    <Box display='flex' flexDirection={flexDirection} width='100%'>
      <Box mr='20px'>
        <Typography variant='h6'>{label}</Typography>
      </Box>
      <Box width={sliderWidth}>
        <Slider
          defaultValue={DEFAULT_NUMBER_OF_ANSWER_CARDS}
          min={1}
          max={5}
          valueLabelDisplay='off'
          marks={marks}
          onChange={onSliderChange}
          aria-label='Number of answer cards'
          {...props}
        />
      </Box>
    </Box>
  );
};

export default ChooseNumberOfCards;
